import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Szme043aResponseClaimBasicInf02Dto } from 'sg-api';
 import { BillDispZyuusyoPipe } from '../../../../../sg-kd-shared/pipes/bill-disp-zyuusyo.pipe';
/**
 * 定額請求基本情報画面
 * @export
 * @class MonthlyBillingBasicInfoComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-monthly-billing-basic-info',
  templateUrl: './monthly-billing-basic-info.component.html',
  styleUrls: ['./monthly-billing-basic-info.component.scss'],
  providers: [ BillDispZyuusyoPipe ]
})
export class MonthlyBillingBasicInfoComponent {
  @Input() billingBasicInfo: Szme043aResponseClaimBasicInf02Dto;

  constructor() { }

}
